var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2", on: { click: _vm.toOrder } }, [
                _vm._v("确定收货"),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "orderInfo" }, [
      _vm._m(0),
      !_vm.is_null(_vm.content)
        ? _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "contentTemp" }, [
              _c("div", { staticClass: "fontTemp" }, [
                _c("span", { staticClass: "span" }, [
                  _vm._v("原单编号: " + _vm._s(_vm.content.orderId)),
                ]),
                _c("span", { staticClass: "span" }, [
                  _vm._v("订单编号: " + _vm._s(_vm.content.returnOrderId)),
                ]),
                _c("span", { staticClass: "span" }, [
                  _vm._v("订单状态: " + _vm._s(_vm.content.returnStatusName)),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "span",
                    staticStyle: { display: "inline-block" },
                  },
                  [
                    _c("span", { staticClass: "span1" }, [_vm._v("时 间")]),
                    _c("span", [_vm._v(":" + _vm._s(_vm.content.applyTime))]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "span",
                    staticStyle: { display: "inline-block" },
                  },
                  [
                    _c("span", { staticClass: "span1" }, [_vm._v("客 服:")]),
                    _c("span", [_vm._v(_vm._s(_vm.content.applyName))]),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "contentTemp" }, [
              _c("div", { staticClass: "fontTemp" }, [
                _c("span", { staticClass: "span" }, [
                  _vm._v(
                    "客户信息: " +
                      _vm._s(_vm.content.customerName) +
                      " " +
                      _vm._s(_vm.content.customerPhone) +
                      " " +
                      _vm._s(_vm.content.userAddress)
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "contentTemp" }, [
              _c("div", { staticClass: "fontTemp" }, [
                _c("span", { staticClass: "span" }, [
                  _vm._v(
                    "收货信息: " +
                      _vm._s(_vm.content.addressName) +
                      " " +
                      _vm._s(_vm.content.addressPhone) +
                      " " +
                      _vm._s(_vm.content.rejectAddress)
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "contentTemp" }, [
              _c("div", { staticClass: "fontTemp" }, [
                !_vm.is_null(_vm.content.comment)
                  ? _c("span", { staticClass: "span" }, [
                      _vm._v("备注: " + _vm._s(_vm.content.comment)),
                    ])
                  : _c("span", { staticClass: "span" }, [_vm._v("备注:无")]),
              ]),
            ]),
            !_vm.is_null(_vm.content.logisticsCompany)
              ? _c("div", { staticClass: "contentTemp" }, [
                  _c("div", { staticClass: "fontTemp" }, [
                    _c("span", { staticClass: "span" }, [
                      _vm._v(
                        "包裹单号: " +
                          _vm._s(_vm.content.logisticsCompany) +
                          " " +
                          _vm._s(_vm.content.parcelNumber)
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "goodDetail" }, [
      _c("div", { staticClass: "title" }, [_vm._v("商品详情")]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "title", staticStyle: { border: "0" } }, [
            _vm._v("商品"),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.content.orderReturnCommodityList,
                "header-cell-style": { color: "#333", textAlign: "center" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "brand", label: "品牌" },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  prop: "commodityName",
                  label: "商品名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "number", label: "退货数量" },
              }),
              _c("el-table-column", {
                attrs: { label: "仓库收货", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "optain" }, [
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("已收")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.receivedNum,
                                      min: 1,
                                      max: scope.row.receivedNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changCountRecived(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.receivedNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "receivedNum", $$v)
                                      },
                                      expression: "scope.row.receivedNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeRecived(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeRecived(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("破损")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.damagedNum,
                                      min: 1,
                                      max: scope.row.damagedNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeCountDamage(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.damagedNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "damagedNum", $$v)
                                      },
                                      expression: "scope.row.damagedNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeDamage(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeDamage(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("漏件")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.missingNum,
                                      min: 1,
                                      max: scope.row.missingNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeCountMissing(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.missingNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "missingNum", $$v)
                                      },
                                      expression: "scope.row.missingNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeMissing(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeMissing(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ￥" + _vm._s(scope.row.price) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationName", label: "规格" },
              }),
              _c("el-table-column", {
                attrs: { label: "退货小计" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ￥" + _vm._s(scope.row.total) + " ")]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "operatingStatus", staticStyle: { border: "0" } },
            [_vm._v("赠品")]
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.content.orderReturnComplimentaryList,
                "header-cell-style": { color: "#333", textAlign: "center" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "brand", label: "品牌" },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  prop: "complimentaryName",
                  label: "商品名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "number", label: "退货数量" },
              }),
              _c("el-table-column", {
                attrs: { label: "仓库收货", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "optain" }, [
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("已收")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.receivedNum,
                                      min: 1,
                                      max: scope.row.receivedNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changCountRecivedZp(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.receivedNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "receivedNum", $$v)
                                      },
                                      expression: "scope.row.receivedNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeRecivedZp(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeRecivedZp(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("破损")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.damagedNum,
                                      min: 1,
                                      max: scope.row.damagedNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeCountDamageZp(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.damagedNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "damagedNum", $$v)
                                      },
                                      expression: "scope.row.damagedNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeDamageZp(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeDamageZp(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "inputDeal" }, [
                            _c("span", [_vm._v("漏件")]),
                            _c(
                              "div",
                              { staticClass: "numer" },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: scope.row.missingNum,
                                      min: 1,
                                      max: scope.row.missingNum,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeCountMissingZp(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row.missingNum,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "missingNum", $$v)
                                      },
                                      expression: "scope.row.missingNum",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "prepend" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeMissingZp(
                                              scope.row,
                                              -1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "prepend",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-minus",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { slot: "append" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeMissingZp(
                                              scope.row,
                                              1,
                                              scope.$index
                                            )
                                          },
                                        },
                                        slot: "append",
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ￥" + _vm._s(scope.row.price) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationName", label: "规格" },
              }),
              _c("el-table-column", {
                attrs: { label: "小计" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ￥" + _vm._s(scope.row.total) + " ")]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          !_vm.is_null(_vm.content)
            ? _c("div", { staticClass: "totalAll" }, [
                _c("span", [
                  _vm._v(
                    "原单总计：共" + _vm._s(_vm.content.orderNumber) + "件"
                  ),
                ]),
                _c("span", [
                  _vm._v("赠品总价 ￥ " + _vm._s(_vm.content.giftTotal)),
                ]),
                _c("span", [
                  _vm._v("商品总价 ￥ " + _vm._s(_vm.content.goodsTotal)),
                ]),
                _c("span", [
                  _vm._v("应收金额 ￥ " + _vm._s(_vm.content.orderMoney)),
                ]),
                _c("span", [
                  _vm._v(
                    "已收金额 ￥ " + _vm._s(_vm.content.orderReceivedMoney)
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    "待收金额 ￥ " + _vm._s(_vm.content.orderAwaitIncomeMoney)
                  ),
                ]),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("div", { staticClass: "totalAll" }, [
                _c("span", [_vm._v("退货总计")]),
                _c("span", [
                  _vm._v("退货 " + _vm._s(_vm.content.returnNumber) + " 件"),
                ]),
                _c("span", [
                  _vm._v("总价 ￥ " + _vm._s(_vm.content.returnMoney)),
                ]),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("div", { staticClass: "totalAll" }, [
                _c("span", [_vm._v("仓库收货总计")]),
                _c("span", [
                  _vm._v("已收 " + _vm._s(_vm.receivedTogether) + " 件"),
                ]),
                _c("span", [
                  _vm._v("破损 " + _vm._s(_vm.damagedTogether) + " 件"),
                ]),
                _c("span", [
                  _vm._v("漏件 " + _vm._s(_vm.missingTogether) + " 件"),
                ]),
                _c("span", [
                  _vm._v("已收货总价 ￥ " + _vm._s(_vm.content.orderTotal)),
                ]),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("div", { staticClass: "total" }, [
                _c("span", [
                  _vm._v(
                    "已收金额 ￥ " + _vm._s(_vm.content.orderReceivedMoney)
                  ),
                ]),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("div", { staticClass: "total" }, [
                _c("span", [
                  _vm._v("应退 ￥ " + _vm._s(_vm.content.shouldReturnMoney)),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "remark" },
      [
        _c("div", { staticClass: "title" }, [_vm._v("备注")]),
        _c("el-input", {
          attrs: { type: "textarea", rows: 2, placeholder: "请输入内容" },
          model: {
            value: _vm.textarea,
            callback: function ($$v) {
              _vm.textarea = $$v
            },
            expression: "textarea",
          },
        }),
      ],
      1
    ),
    _c("div", { staticStyle: { height: "70px" } }),
    _c(
      "div",
      { staticClass: "submit" },
      [
        _c(
          "el-button",
          {
            staticStyle: { width: "100px" },
            attrs: { type: "primary", plain: "", size: "mini" },
            on: {
              click: function ($event) {
                return _vm.submitEvent(1)
              },
            },
          },
          [_vm._v("驳回")]
        ),
        _c(
          "el-button",
          {
            staticStyle: { width: "100px" },
            attrs: { type: "primary", size: "mini" },
            on: {
              click: function ($event) {
                return _vm.submitEvent(2)
              },
            },
          },
          [_vm._v("确定收货")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("订单信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }